import { useEffect, useRef } from "react";
import { Box as ChakraBox } from "@chakra-ui/react";
import { animate } from "motion/react";

export default function AnimatedDot() {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current) return;

    const animation = animate(
      ref.current,
      { opacity: [0, 1, 1, 0, 0] },
      {
        duration: 2.6,
        times: [0, 0.12, 0.7, 0.82, 1],
        repeat: Infinity
      }
    );

    return () => animation.stop();
  }, []);

  return <ChakraBox ref={ref} w="12" h="12" minW="12" bg="green.60" borderRadius="100%" />;
}
